define(
    'common/config',['./utils', './apiVersion', './ajaxConfig'],
    function(utils, apiVersion) {
        'use strict';
        var PROTOCOL_HTTP = 'http:',
          PROTOCOL_HTTPS = 'https:';

        /**
         * File to contain basebath of api
         */
        var apiBasePath = '../../api/',
            baseConfig = {
                apiBasePath: apiBasePath,
                apiVersion: apiVersion.apiVersion,
                paths: {
                    uiVersion: './version.properties',
                    apiVersion: apiBasePath + 'site/version'
                },
                constants: {
                    PROTOCOL_HTTP: PROTOCOL_HTTP,
                    PROTOCOL_HTTPS: PROTOCOL_HTTPS
                }
            };
            // + baseConfig.apiVersion add when api version is available
        baseConfig.apiPath = baseConfig.apiBasePath;
        
        //!ToDo Is it required
        var cid = utils.parseURL(document.URL).query.CID;

        if (!cid) {
            baseConfig.customerId = '';
        } else {
            baseConfig.customerId = cid;
        }

        /**
         * In case the user is using http protocol, we'll move it to https: protocol
         */
        if (PROTOCOL_HTTP === window.location.protocol) {
            baseConfig.canProcede = false;
            // window.setTimeout(function() {
            //     window.location.replace(PROTOCOL_HTTPS + window.location.href.split(PROTOCOL_HTTP)[1]);
            // }, 500);
        } else {
            baseConfig.canProcede = true;
        }
        
        return baseConfig;
    });
